import React from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    // A URL like /#pricing names its own scroll target, so the page that
    // owns that anchor positions itself. Yanking to the top would undo it.
    if (hash) return;

    window.scroll({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return (<>{children}</>);
};

export default ScrollToTop;